export default {

    Permissions: 'User|Users',
};
